// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import SttFoldersTable from './stt-folders-table';
// assets
//

// ----------------------------------------------------------------------

export default function SttFolders() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <SttFoldersTable />
        </Container >
    );
}
